<script setup lang="ts">
import { computed, watch } from 'vue'
import { useField } from 'vee-validate'
import Calendar from 'primevue/calendar'
import { formatedDate } from '@/constants'
import InputText from 'primevue/inputtext'

const props = defineProps<{
  modelValue?: any
  inputName: string
  disabled?: boolean
}>()

const emit = defineEmits(['update:modelValue'])

const { value, errorMessage } = useField<any>(props.inputName)

const computedValue = computed({
  get: () => {
    if (!props.modelValue) return null

    // If the value is already a Date, return it
    if (props.modelValue instanceof Date) return props.modelValue

    // Convert ISO string to Date object
    return new Date(props.modelValue)
  },
  set: (newVal: any) => {
    value.value = newVal
    emit('update:modelValue', newVal)
  }
})
// This computed is for formatting the date when 'disabled' is true
const formatedKnittedDate = computed(() => {
  // Format the date only if it's present and valid, else return an empty string
  return computedValue.value ? formatedDate(computedValue.value) : ''
})
watch(computedValue, (newValue) => {
  emit('update:modelValue', newValue)
})
</script>

<template>
  <div class="flex flex-col gap-2">
    <label for="dateKinitted">Date Knitted:</label>
    <InputText v-if="disabled" v-model="formatedKnittedDate" :disabled="disabled" />
    <Calendar
      v-else
      id="dateKinitted"
      :invalid="!!errorMessage"
      v-model="computedValue"
      showIcon
      iconDisplay="input"
      :disabled="disabled"
      dateFormat="dd/mm/yy"
    />
  </div>
</template>

<style scoped></style>
